export default __webpack_public_path__ + "static/media/account_circle.f4f374ab.svg";